module.exports = __webpack_public_path__ + "img/20_45.3f5f4e97.png";